import React, { useState, useEffect } from 'react';
import { Button, Form, Upload, Modal, App } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { UploadFile, UploadProps } from 'antd';
import { saveServiceProduct } from '@/api/Services';
import { useAppSelector } from '@/store/hooks';
import { useNavigate, useSearchParams } from 'react-router-dom';

// import { IFormDataAll } from '../../types';
import ProductDetailTemplate1 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate1/ProductDetailTemplate1';
import ProductDetailTemplate2 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate2/ProductDetailTemplate2';
import ProductDetailTemplate3 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate3/ProductDetailTemplate3';
import ProductDetailTemplate4 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate4/ProductDetailTemplate4';
import ProductDetailTemplate5 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate5/ProductDetailTemplate5';
import ProductDetailTemplate6 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate6/ProductDetailTemplate6';
import ProductDetailTemplate7 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate7/ProductDetailTemplate7';
import styles from './Step3.module.scss';

// 扩展 UploadFile 类型，添加 file_id 字段
interface ExtendedUploadFile extends UploadFile {
  file_id?: number | null;
}

// 定义完整的表单数据类型
interface ServiceFormData {
  product_service_id?: string | null; // 添加服务产品ID字段
  step1: {
    category: number;
    mainImages: Array<{
      product_service_id: number | null;
      product_media_type: string;
      product_media_file_url: string;
      product_media_video_cover_id: number | null;
      file_id: number | null;
      product_media_id: number | null;
    }>;
    title: string;
    desc: string;
    customAttrs: Array<{ key: string; value: string }>;
  };
  step2: {
    attributes: Array<{
      name: string;
      img: string;
      is_on_shelf: boolean;
    }>;
    specs: Array<{
      name: string;
      price: number;
      duration: number;
      is_on_shelf: boolean;
    }>;
    reservationOpen: boolean;
    reservationTimes: string[];
  };
  step3: {
    product_content?: any[];
    video_attachments?: Array<{
      product_service_id: string;
      product_media_type: string;
      product_media_file_url: string;
    }>;
  };
}

export interface Step3Props {
  onNext?: (submitData: any) => void;
  onPrev?: () => void;
  formData?: ServiceFormData; // 接收前面步骤的数据
}

//模板列表
const templateList = [
  {
    name: 'template1',
    title: 'Lightweight and portable',
    content: 'The lightweight structure makes it easy to use at home or on the go, adding convenience to your everyday life.',
    imgUrl: [
      {
        url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
        name: "",
      },
    ]
  },
  {
    name: 'template2',
    title: 'Handwoven with care',
    content: 'Each basket is carefully handwoven by skilled artisans, offering both durability and a unique, natural charm.',
    imgUrl: [
      {
        url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
        name: "",
      },
    ]
  },
  {
    name: 'template3',
    title: 'Dominique Galvan',
    contentList: [
      {
        title: 'Dominique Galvan',
        content: 'Dominique Galvan ',
      },
      {
        title: 'Dominique Galvan',
        content: 'Dominique Galvan ',
      },
      {
        title: 'Dominique Galvan',
        content: 'Dominique Galvan ',
      },
    ],
    imgUrl: [
      {
        url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
        name: "",
      },
    ]
  },
  {
    name: 'template4',
    contentList: [
      {
        title: 'Square Storage Basket',
        content1: '13.78*9.84* 5.91',
        content2: 'Natural bamboo strips',
        imgUrl: [
          {
            url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
            name: "",
          },
        ]
      },
      {
        title: 'Striped Handheld Basket',
        content1: '13.78*9.84* 5.91',
        content2: 'Natural bamboo strips',
        imgUrl: [
          {
            url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
            name: "",
          },
        ]
      },
      {
        title: 'Dominique Galvan',
        content1: '13.78*9.84* 5.91',
        content2: 'Natural bamboo strips',
        imgUrl: [
          {
            url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
            name: "",
          },
        ]
      },
    ],

  },

  {
    name: 'template5',
    imgUrl: [
      {
        url: "https://www.easysolarsupply.com/api/upload_files/090c1c01851c44b69769e3294beba6ba.png",
        name: "",
      },
    ]
  },
  {
    name: 'template6',
    title: 'Dominique Galvan',
    contentList: [
      {
        leftTitle: 'Height:',
        rightTitle: '555mm',
      },
      {
        leftTitle: 'Length:',
        rightTitle: '1600mm',
      },
      {
        leftTitle: 'Material:',
        rightTitle: 'Acrylic',
      },
      {
        leftTitle: 'Size:',
        rightTitle: '2200x1200x720mm',
      },
    ],
  },
  {
    name: 'template7',
    title: 'Hand Woven Process',
    content: 'Crafted Weaves,Strict Checks',
    imgUrl: [
     
    ]
  },
];


// 服务发布第三步：详细描述和附件
const Step3: React.FC<Step3Props> = ({
  onNext,
  onPrev,
  formData
}) => {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();



  //产品详情模板内容
  const [productContent, setProductContent] = useState<any[]>([
  ]);

  // 文件上传相关状态
  const [fileList, setFileList] = useState<ExtendedUploadFile[]>([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  // 获取token
  const token = useAppSelector((state) => state.user.token);

  // 初始化数据
  useEffect(() => {
    console.log('Step3 formData:', formData);
    if (formData) {
      // 设置富文本内容
      if (formData.step3 && formData.step3.product_content) {
        setProductContent(formData.step3.product_content);
      }

      // 设置视频附件列表
      if (formData.step3 && formData.step3.video_attachments && formData.step3.video_attachments.length > 0) {
        const videoAttachments = formData.step3.video_attachments.map((item: any, index: number) => ({
          uid: `video-${index}`,
          name: `video-${index}.mp4`,
          status: 'done' as const,
          url: item.product_media_file_url,
          product_media_type: item.product_media_type,
          product_service_id: item.product_service_id
        }));
        setFileList(videoAttachments);
      } 
    }
  }, [formData]);

  // 附件上传配置
  const attachmentProps: UploadProps = {
    name: 'file',
    action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
    accept: ".mp4,.mov,.avi,.wmv,.flv,.mpeg,.mpg,.m4v,.webm,.mkv",
    headers: {
      token: `${token}`,
    },
    listType: 'picture-card',
    fileList: fileList,
    beforeUpload: (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error("Image must be smaller than 10MB!");
      }
      return isLt10M; // 返回 false 阻止上传
    },
    onChange(info) {
      // 复制一份文件列表
      const newFileList = [...info.fileList];

      // 对文件状态进行处理
      newFileList.forEach(file => {
        if (file.response) {
          file.url = file?.response?.data?.url;
          (file as ExtendedUploadFile).file_id = file?.response?.data?.file_id || null;
        }
      });
      // 更新状态
      setFileList(newFileList);
    },
    onPreview: async (file) => {
      // 预览逻辑
      let src = file.url as string;
      if (!src) {
        src = await new Promise(resolve => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj as any);
          reader.onload = () => resolve(reader.result as string);
        });
      }
      setPreviewImage(src);
      setPreviewOpen(true);
      setPreviewTitle(file.name || 'Preview');
    }
  };



  // 处理提交
  const handleSubmit = () => {
    if (!formData) {
      message.error('No form data available');
      return;
    }

    // 从formData中提取前面步骤的数据
    const step1Data = formData.step1 || {};
    const step2Data = formData.step2 || {};

    // 构建完整的提交数据，包含前面所有步骤的数据
    const submitData: any = {
      // 服务产品ID - 用于编辑时回传
      product_service_id: formData?.product_service_id || '',
      // Step1 数据
      product_category_id: step1Data.category || 0,
      product_main_images: step1Data.mainImages || [],
      service_name: step1Data.title || '',
      service_description: step1Data.desc || '',
      custom_attributes: step1Data.customAttrs || [],
      // Step2 数据
      sales_attributes: step2Data.attributes || [],            
      sales_specifications: step2Data.specs || [],             
      reservation_service_enabled: step2Data.reservationOpen || false,  
      reservation_time_slots: step2Data.reservationTimes || [],
      // Step3 数据
      service_detail_content: productContent,
      // 视频附件数据
      service_video_attachments: fileList.map(file => ({
        product_service_id: null,
        product_media_type: "video",
        product_media_file_url: file.url || '',
        product_media_video_cover_id: null,
        file_id: file.file_id || null,
      }))
    };
    // 根据url的id区分新增与编辑
    const urlId = searchParams.get('id');
    if (urlId) {
      const parsedId = Number(urlId);
      submitData.product_service_id = Number.isNaN(parsedId) ? urlId : parsedId;
    }
    // const submitData1 = {
    //   // Step1
    //   product_category_id: 1,                    //  产品分类ID (number类型)
    //   product_main_images: [                     //  产品主图数组
    //     {
    //       product_id: null,
    //       product_media_type: "images",
    //       product_media_file_url: "https://example.com/image1.jpg",
    //       product_media_video_cover_id: null,
    //       file_id: 123,
    //       product_media_id: null
    //     }
    //   ],
    //   service_name: "专业清洁服务",               //  服务名称
    //   service_description: "提供专业的家庭清洁服务", //  服务描述
    //   custom_attributes: [                       //  自定义属性数组
    //     {
    //       key: "营业时间",
    //       value: "周一至周六: 9:00 AM - 7:00 PM"
    //     }
    //   ],
      
    //   // Step2
    //   sales_attributes: [                        //  销售属性数组
    //     {
    //       name: "清洁类型",
    //       img: "https://example.com/cleaning.jpg",
    //       is_on_shelf: true
    //     }
    //   ],
    //   sales_specifications: [                    //  销售规格数组
    //     {
    //       name: "清洁类型",
    //       price: 75,                             // number类型，建议用中间值
    //       duration: 60,                          // number类型
    //       is_on_shelf: true
    //     }
    //   ],
    //   reservation_service_enabled: true,         //  预约服务开关
    //   reservation_time_slots: [                 //  预约时间段数组
    //     "09:00 - 11:00",                       //  修复：只保留时间范围
    //     "14:00 - 16:00"                        //  修复：只保留时间范围
    //   ],
      
    //   // Step3
    //   service_detail_content: [                  //  服务详情内容数组
    //     {
    //       name: "template1",
    //       title: "Lightweight and portable",
    //       content: "The lightweight structure makes it easy to use...",
    //       imgUrl: [
    //         {
    //           url: "https://example.com/template1.jpg",
    //           name: ""
    //         }
    //       ]
    //     }
    //   ],
    //   service_video_attachments: [               //  服务视频附件数组
    //     {
    //       product_id: null,
    //       product_media_type: "video",
    //       product_media_file_url: "https://example.com/video1.mp4",
    //       product_media_video_cover_id: null
    //     }
    //   ]
    // };
    console.log(submitData, 'submitData');
    saveServiceProduct(submitData).then(res => {
      if(res.code === 200){
        console.log(res.data.data, 'res.data.data');
        message.success('Service saved successfully');
        setTimeout(() => {
          navigate('/yourtownloop/yourProducts?category=service');
        }, 1000);
      }else{
        message.error('Service saved failed');
      }
    });

    // 暂时直接调用onNext传递数据
    if (onNext) {
      onNext(submitData);
    } else {
      message.success('Service data prepared successfully');
    }
  };

  // 返回上一步
  const handlePrev = () => {
   
    onPrev && onPrev();
  };

  // 取消预览
  const handleCancel = () => setPreviewOpen(false);

  // 上传按钮
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  // 判断文件类型
  const isVideoFile = (fileName: string) => {
    const videoExtensions = ['.mp4', '.mov', '.avi', '.wmv', '.flv', '.mpeg', '.mpg', '.m4v', '.webm', '.mkv'];
    return videoExtensions.some(ext => fileName.toLowerCase().includes(ext));
  };

  // 处理模板内容变更
  const handleTemplateChange = (data: any, index: number) => {
    const newProductContent = [...productContent];
    newProductContent[index] = data;
    setProductContent(newProductContent);
  };

  //删除模板
  const handleDeleteTemplate = (index: number) => {
    const newProductContent = [...productContent];
    newProductContent.splice(index, 1);
    setProductContent(newProductContent);
  };

  return (
    <div className={styles['store-publish-product-step4']}>
      <div className={styles['main-title']}>Service Details</div>
      {/* 附件上传 */}
      <div className={styles['section']}>
          <div className={styles['section-title']}>
              Graphic Description
          </div>
          <div className={styles['attachment-description']}>
            Video requirements(Duration: 5 seconds to 5 minutes/ Aspect ratios supported: 1:1, 3:4, 9:16/ Maximum uploads: 5 videos)
          </div>
          <div className={styles['attachment-upload-container']}>
            <Upload {...attachmentProps}>
              {fileList.length >= 5 ? null : uploadButton}
            </Upload>
          </div>
          <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
            {isVideoFile(previewTitle) ? (
              <video 
                controls 
                style={{ width: '100%', maxHeight: '70vh' }}
                src={previewImage}
              >
                Your browser does not support the video tag.
              </video>
            ) : (
              <img alt="preview" style={{ width: '100%' }} src={previewImage} />
            )}
          </Modal>
        </div>
        {/* 服务详情 */}
      <Form form={form} layout="vertical">
        <div className={styles['section']}>
          <div className={styles['section-title']}>
            <span className={styles['required']}>*</span>
            Service Description
          </div>
          <div className={styles['template-buttons']}>
            <Button onClick={() => setProductContent([...productContent, templateList[0]])}>Template 1 - Image with Text</Button>
            <Button onClick={() => setProductContent([...productContent, templateList[1]])}>Template 2 - Feature Highlight</Button>
            <Button onClick={() => setProductContent([...productContent, templateList[2]])}>Template 3 - Specifications</Button>
            <Button onClick={() => setProductContent([...productContent, templateList[3]])}>Template 4 - Product Grid</Button>
            <Button onClick={() => setProductContent([...productContent, templateList[4]])}>Template 5 - Full Width Image</Button>
            <Button onClick={() => setProductContent([...productContent, templateList[5]])}>Template 6 - Specifications Table</Button>
            <Button onClick={() => setProductContent([...productContent, templateList[6]])}>Template 7 - Full Width Video</Button>
          </div>
          <div className={styles['rich-editor-container']}>


            {
              productContent.map((item, index) => {
                if (item.name === 'template1') {
                  return (
                    <div key={index} className={styles['template-container']}>
                      <div className={styles['delete-box']}>
                        <Button className={styles['delete-template-btn']} onClick={() => handleDeleteTemplate(index)}>Delete Template</Button>
                      </div>
                      <ProductDetailTemplate1 data={item} selfIndex={index} onChange={(data, i) => handleTemplateChange(data, i)} />
                    </div>
                  )
                } else if (item.name === 'template2') {
                  return (
                    <div key={index} className={styles['template-container']}>
                      <div className={styles['delete-box']}>
                        <Button className={styles['delete-template-btn']} onClick={() => handleDeleteTemplate(index)}>Delete Template</Button>
                      </div>
                      <ProductDetailTemplate2 data={item} selfIndex={index} onChange={(data, i) => handleTemplateChange(data, i)} />
                    </div>
                  )
                } else if (item.name === 'template3') {
                  return (
                    <div key={index} className={styles['template-container']}>
                      <div className={styles['delete-box']}>
                        <Button className={styles['delete-template-btn']} onClick={() => handleDeleteTemplate(index)}>Delete Template</Button>
                      </div>
                      <ProductDetailTemplate3 data={item} selfIndex={index} onChange={(data, i) => handleTemplateChange(data, i)} />
                    </div>
                  )
                } else if (item.name === 'template4') {
                  return (
                    <div key={index} className={styles['template-container']}>
                      <div className={styles['delete-box']}>
                        <Button className={styles['delete-template-btn']} onClick={() => handleDeleteTemplate(index)}>Delete Template</Button>
                      </div>
                      <ProductDetailTemplate4 data={item} selfIndex={index} onChange={(data, i) => handleTemplateChange(data, i)} />
                    </div>
                  )
                } else if (item.name === 'template5') {
                  return (
                    <div key={index} className={styles['template-container']}>
                      <div className={styles['delete-box']}>
                        <Button className={styles['delete-template-btn']} onClick={() => handleDeleteTemplate(index)}>Delete Template</Button>
                      </div>
                      <ProductDetailTemplate5 data={item} selfIndex={index} onChange={(data, i) => handleTemplateChange(data, i)} />
                    </div>
                  )
                } else if (item.name === 'template6') {
                  return (
                    <div key={index} className={styles['template-container']}>
                      <div className={styles['delete-box']}>
                        <Button className={styles['delete-template-btn']} onClick={() => handleDeleteTemplate(index)}>Delete Template</Button>
                      </div>
                      <ProductDetailTemplate6 data={item} selfIndex={index} onChange={(data, i) => handleTemplateChange(data, i)} />
                    </div>
                  )
                } else if (item.name === 'template7') {
                  return (
                    <div key={index} className={styles['template-container']}>
                      <div className={styles['delete-box']}>
                        <Button className={styles['delete-template-btn']} onClick={() => handleDeleteTemplate(index)}>Delete Template</Button>
                      </div>
                      <ProductDetailTemplate7 data={item} selfIndex={index} onChange={(data, i) => handleTemplateChange(data, i)} />
                    </div>
                  )
                }
                return null;
              })
            }
          </div>
        </div>

        

        <div className={styles['button-container']}>
          <Button
            className={styles['prev-button']}
            onClick={handlePrev}
          >
            Prev
          </Button>
          <Button
            type="primary"
            className={styles['submit-button']}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Step3; 